import { Component, Input, OnInit } from "@angular/core";
import { EditUserViewModel } from "../../../ViewModels/EditUserViewModel";

@Component({
  selector: "evrideo-user-channel-permissions",
  templateUrl: "./user-channel-permissions.component.html",
  styleUrls: ["./user-channel-permissions.component.scss"],
})
export class UserChannelPermissionsComponent implements OnInit {
  @Input()
  userVM: EditUserViewModel;
  constructor() {}

  ngOnInit() {}
}
